module.exports = __webpack_public_path__ + "static/start online-7c5ab7bb16a89d708359e72aa24830bc.svg";